module.exports = __webpack_public_path__ + "static/media/wip.43836b9a.png";